import { getBrowserStorage } from "./browserStorage";

const STORAGE_KEY = "tavela.musicVolumePercent";
export const DEFAULT_MUSIC_VOLUME_PERCENT = 60;

function parseMusicVolume(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim().length > 0) {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  return null;
}

function normalizeMusicVolume(value: unknown): number {
  const parsedValue = parseMusicVolume(value);
  if (parsedValue === null) {
    return DEFAULT_MUSIC_VOLUME_PERCENT;
  }

  return Math.min(100, Math.max(0, Math.round(parsedValue)));
}

export function loadMusicVolume(): number {
  const storage = getBrowserStorage();
  if (storage === null) {
    return DEFAULT_MUSIC_VOLUME_PERCENT;
  }

  try {
    const storedValue = storage.getItem(STORAGE_KEY);
    if (storedValue === null) {
      return DEFAULT_MUSIC_VOLUME_PERCENT;
    }

    return normalizeMusicVolume(JSON.parse(storedValue));
  } catch {
    return DEFAULT_MUSIC_VOLUME_PERCENT;
  }
}

export function saveMusicVolume(value: unknown): number {
  const nextVolume = normalizeMusicVolume(value);
  const storage = getBrowserStorage();
  if (storage === null) {
    return nextVolume;
  }

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(nextVolume));
  } catch {
    // Ignore storage write failures so music defaults still work.
  }

  return nextVolume;
}
